import { DeleteButton } from "@/components/admin";
import type { Identifier } from "ra-core";
import { useTranslate } from "ra-core";
import { EditSheet } from "../misc/EditSheet";
import { TaskFormContent } from "./TaskFormContent";
import { TaskMeetingPlayback } from "./TaskMeetingPlayback";

export interface TaskEditSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  taskId: Identifier;
}

export const TaskEditSheet = ({
  open,
  onOpenChange,
  taskId,
}: TaskEditSheetProps) => {
  const translate = useTranslate();
  return (
    <EditSheet
      resource="tasks"
      id={taskId}
      title={
        <h1 className="text-xl font-semibold truncate pr-10">
          {translate("resources.tasks.sheet.edit")}
        </h1>
      }
      redirect={false}
      open={open}
      onOpenChange={onOpenChange}
      deleteButton={
        <DeleteButton
          variant="destructive"
          className="flex-1"
          redirect={false}
          onClick={() => {
            onOpenChange(false);
          }}
        />
      }
    >
      <TaskFormContent showSales showDone showContact />
      <TaskMeetingPlayback />
    </EditSheet>
  );
};
